/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const response = axios
    .get(`https://${url}/api/method/frappe.auth.get_logged_user`, {
      withCredentials: true,
    })
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchLoggedUser = () => {
  const { url } = useSelector(selectAuth);
  return useQuery(['logged-user', url], fetcher);
};
